import React from "react";
import CompanyReportSection from "shared/reports/components/companyReportSection/CompanyReportSection";
import ReportsCollectionWrapper from "shared/reports/components/reportsCollectionWrapper/ReportsCollectionWrapper";
import { ScorecardGoal } from "goalsCard/service/api/models";
import ManagerReportCell from "../managerReportCell/ManagerReportCell";

interface CompanyGoalsSummaryReportSectionProps {
    companyName?: string;
    goals: ScorecardGoal[];
    todayProgressValue: number | undefined;
    additionalClassName?: string;
}

const CompanyGoalsSummaryReportSection: React.FC<CompanyGoalsSummaryReportSectionProps> = (
    props: CompanyGoalsSummaryReportSectionProps
) => {
    const renderGoalSummary = (report: ScorecardGoal) => {
        return (
            <ManagerReportCell
                report={report}
                showTodayProgressValue={true}
                todayProgressValue={props.todayProgressValue}
            />
        );
    };

    const getReportElementTitle = (goal: ScorecardGoal) => {
        return goal.title;
    };

    const getReportElementText = (goal: ScorecardGoal) => {
        return goal.text;
    };

    const getReportContents = () => {
        if (!props.goals) {
            return null;
        }

        return (
            <ReportsCollectionWrapper
                reports={props.goals}
                reportElementTitle={getReportElementTitle}
                reportElementText={getReportElementText}
                renderReportElement={renderGoalSummary}
                isCompactView={true}
            />
        );
    };

    return (
        <CompanyReportSection
            companyName={props.companyName}
            reportContents={getReportContents()}
            additionalClassName={props.additionalClassName}
        />
    );
};

export default CompanyGoalsSummaryReportSection;
